module.exports = __webpack_public_path__ + "img/framework.67098449.png";